import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { LinkButton } from '../../../components';
import User from '../store/User';
import classes from './UserTable.module.scss';

export default observer(function UserTable({ users }: { users: User[] }) {
  const navigate = useNavigate();

  function showUser(userId: string) {
    navigate(`/users/${userId}`);
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Developer Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Webhooks</TableCell>
            <TableCell align="right">&nbsp;</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <TableRow
              className={classes.row}
              key={user.id}
              onClick={() => showUser(user.id)}
            >
              <TableCell scope="row">{user.id}</TableCell>
              <TableCell>{user.name}</TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>{user.role}</TableCell>
              <TableCell>
                {user.configurations.isWebhookEnabled ? '✓' : ''}
              </TableCell>
              <TableCell align="right">
                <LinkButton
                  icon="pen"
                  size="small"
                  to={`/users/${user.id}`}
                  type="primaryText"
                >
                  Edit
                </LinkButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
});
